import styled from 'styled-components';
const Fieldset = styled.fieldset``;

export default Fieldset;
